import * as Ons from 'react-onsenui';
import { ROSTERS_UNLOCKED } from '../store/constants/statusCodes';
import { supports } from './context';
import { translate as _ } from './i18n';

let urlParameters = null;

const parseUrlParameters = () => {

    urlParameters = {};

    let params = window.location.search;

    if ( params ) {

        params = params.substring( 1 ).split( '&' ).forEach( param => {

            param = param.split( '=' );

            urlParameters[ param[ 0 ] ] = param[ 1 ];

        } );

    }

};

export const coloredLabel = ( e, noHtml ) => {

    if ( ! e ) {

        return '';

    }

    let sum = 0;

    for ( let i = 0; i < e.length; i++ ) {

        sum += e.charCodeAt( i );

    }

    if ( noHtml ) {

        return ' [' + e + ']';

    }

    const className = 'label label-' + ( sum % 5 );

    return <span className={className}>{e}</span>;

};

export const deepCopy = e => window.structuredClone ? window.structuredClone( e ) : parseJSON( JSON.stringify( e ) );

export const expired = e => {

    if ( ! e ) {

        return true;

    }

    if ( ! ( e instanceof Date ) ) {

        e = new Date( e );

    }

    const expirationDate = new Date();

    expirationDate.setHours( expirationDate.getHours() - 1 );

    return e < expirationDate;

};

export const getActionButtonPosition = userSettings => ( 'actionButtonPosition' in userSettings ) ? userSettings.actionButtonPosition : 2;

export const getRosterPublicStatusClass = ( context, roster, team ) => supports( context, 'rosterPublishing' ) && roster && roster.rosterStatus && ( roster.rosterStatus === ROSTERS_UNLOCKED && ! roster[ team + 'RosterIsPublic' ] ? 'roster-public-status-unpublished' : 'roster-public-status-published' );

export const getRosterPublicStatusIcon = ( context, game, team ) => supports( context, 'rosterPublishing' ) && game.rosterStatus && <Ons.Icon className="roster-public-status" icon={game.rosterStatus === ROSTERS_UNLOCKED && ! game[ team + 'RosterIsPublic' ] ? 'fa-eye-slash' : 'fa-eye'} />;

export const getUrlParameter = parameterName => {

    ! urlParameters && parseUrlParameters();

    return urlParameters[ parameterName ];

};

export const getWeekday = date => {

    return [ _( 'Sonntag' ), _( 'Montag' ), _( 'Dienstag' ), _( 'Mittwoch' ), _( 'Donnerstag' ), _( 'Freitag' ), _( 'Samstag' ) ][ date.getDay() ];

};

export const hasLocalChanges = e => {

    for ( let i = 0; i < e.length; i++ ) {

        for ( let j = 0; j < e[ i ].length; j++ ) {

            if ( e[ i ][ j ].locallyChanged ) {

                return true;

            }

        }

    }

    return false;

};

export const isAbsent = player => ( player && player.lineupData && player.lineupData.position && player.lineupData.position.indexOf( '#ABSENT' ) !== -1 );

export const parseJSON = e => {

    if ( ! e ) {

        return null;

    }

    try {

        return JSON.parse( e );

    } catch( f ) {

        return e;

    }

};

export const reload = () => setTimeout( () => window.location.reload(), 200 );

export const shorten = ( e, maxLength = 3 ) => {

    if ( ! e || ! ( typeof e === 'string' ) || e.length <= maxLength ) {

        return e;

    }

    return e.substr( 0, maxLength ) + '..';

}